/** All rewards participants can open the market feed. */
export const TRADE_HREF = '/markets';
